import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=09d288a0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d288a0"]])

export default __exports__